<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7">
      <path d="M17 8.16v.745c-.002 3.585-2.334 6.742-5.732 7.758-3.397 1.017-7.05-.35-8.98-3.357a8.171 8.171 0 0 1 .63-9.666 7.937 7.937 0 0 1 9.338-2.134"/>
      <path d="M17 2.429l-8 8.103-2.4-2.429"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'ic-check-circle'
  }
</script>
